(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-archive"]) return;
  try {
    
(function () {
  var items    = Array.from(document.querySelectorAll('.bc-archive__item'));
  var list     = document.getElementById('bc-archive-list');
  var emptyEl  = document.getElementById('bc-archive-empty');
  var sortBtns = document.querySelectorAll('.bc-archive__sort-pill');
  var searchToggle = document.getElementById('bc-search-toggle');
  var searchWrap   = document.getElementById('bc-search-wrap');
  var searchInput  = document.getElementById('bc-archive-search');

  var activeQuery = '';
  var activeSort  = 'newest';

  function applyFilters() {
    var visible = 0;
    items.forEach(function (item) {
      var match = !activeQuery || item.dataset.headline.includes(activeQuery) || (item.dataset.category || '').includes(activeQuery);
      item.hidden = !match;
      if (match) visible++;
    });
    if (emptyEl) emptyEl.hidden = visible > 0;
  }

  function applySort(method) {
    var sorted = items.slice().sort(function (a, b) {
      if (method === 'oldest') return Number(a.dataset.date) - Number(b.dataset.date);
      if (method === 'az')     return a.dataset.headline.localeCompare(b.dataset.headline);
      return Number(b.dataset.date) - Number(a.dataset.date);
    });
    sorted.forEach(function (item) { list.appendChild(item); });
  }

  /* Sort pills */
  sortBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeSort = this.dataset.sort;
      sortBtns.forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
      applySort(activeSort);
    });
  });

  /* Search toggle */
  if (searchToggle && searchWrap && searchInput) {
    searchToggle.addEventListener('click', function () {
      var open = searchWrap.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open);
      if (open) {
        searchInput.focus();
      } else {
        searchInput.value = '';
        activeQuery = '';
        applyFilters();
      }
    });

    searchInput.addEventListener('input', function () {
      activeQuery = this.value.toLowerCase().trim();
      applyFilters();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchWrap.classList.contains('is-open')) {
        searchWrap.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchInput.value = '';
        activeQuery = '';
        applyFilters();
      }
    });
  }

  /* Apply default sort on load */
  applySort('newest');
})();

  } catch(e) { console.error(e); }
})();
})();
